import { hashKey, useQuery } from '@tanstack/react-query';

import { CompanyCriteria, Importer } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useImporters = (criteria: CompanyCriteria) =>
  useQuery({
    queryKey: ['importers', hashKey([criteria])],
    queryFn: async (): Promise<Importer[]> => {
      try {
        const data = await request({
          path: `importer/retrieve-importers`,
          method: 'POST',
          authenticate: true,
          dataObject: { criteria },
        });
        return data.importers;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch importers');
      }
    },
  });
